import React from "react";
import { cn } from "../../lib/cn";

function SearchAddon({ placeholder, enterButton, ...rest }) {
  return (
    <div className="flex w-full items-stretch overflow-hidden rounded-xl border border-slate-200 focus-within:border-brand focus-within:ring-2 focus-within:ring-brand/20">
      <input
        className="min-w-0 flex-1 border-0 px-3 py-2 text-sm outline-none"
        placeholder={placeholder}
        {...rest}
      />
      {enterButton ? (
        <span className="flex items-center bg-brand px-3 text-xs font-semibold text-white">
          {enterButton}
        </span>
      ) : null}
    </div>
  );
}

export function Input({ className, prefix, ...props }) {
  return (
    <div className="relative flex w-full items-center">
      {prefix ? (
        <span className="absolute left-3 text-slate-400">{prefix}</span>
      ) : null}
      <input
        className={cn(
          "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm outline-none ring-brand/25 transition focus:border-brand focus:ring-2",
          prefix && "pl-10",
          className
        )}
        {...props}
      />
    </div>
  );
}

export function TextArea({ className, ...props }) {
  return (
    <textarea
      className={cn(
        "w-full min-h-[100px] rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm outline-none ring-brand/25 transition focus:border-brand focus:ring-2",
        className
      )}
      {...props}
    />
  );
}

export function InputNumber(props) {
  return <Input type="number" {...props} />;
}

Input.Search = SearchAddon;
Input.TextArea = TextArea;
